import { useEffect, useContext, useState, useRef } from "react";
import { ListItem, ListItemButton, ListItemText } from "@mui/material";

import MUICard from "../../../Component/UI/MUICard/MUICard";
import MUIList from "../../../Component/UI/MUIList/MUIList";
import { DiscoveryContext } from "../discovery-context";
import ErrorView from "../../../Component/ErrorView/ErrorView";
import api from "../../../BrandOnBoarding/api";
import MUIToolTip from "../../../Component/UI/MUIToolTip/MUIToolTip";
import LoadingSkeleton from "./LoadingSkeleton";
import classes from "./Attributes.module.css";

export default function Attributes({ entity, market }) {
  const discoveryCtx = useContext(DiscoveryContext);
  const discoveryType = discoveryCtx.type || "brand";
  const abortControllerRef = useRef(null);


  useEffect(() => {
    if (discoveryCtx.abort_launch) {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    }
  }, [discoveryCtx.abort_launch]);

  useEffect(() => {
    if (Object.keys(discoveryCtx.positive_negative_attributes).length > 0)
      return;
    // getPositiveNegativeAttributes();

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [entity, Object.keys(discoveryCtx.positive_negative_attributes).length]);

  const renderRow = (item, index) => {
    const isEven = index % 2 === 0;
    const isFirst = index === 0;

    const style = {
      background: isEven ? "#F8FAFB" : "#FFFFFF",
      borderTop: isFirst
        ? "1px solid #9d9d9d"
        : isEven
          ? "none"
          : "1px solid #eef2f6",
      borderBottom: !isEven ? "1px solid #eef2f6" : "none",
    };

    let attributeName = item;
    let sources = [];

    if (typeof item === "object") {
      attributeName = item.name;
      sources = item?.sources
        ? item.sources.map((source) => ({ source: source, snippet: "" }))
        : [];
    }

    return (
      <ListItem disablePadding style={style} key={index}>
        <ListItemButton
          className={classes.list_btn}
          sx={{
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <MUIToolTip
            additionalText={`${discoveryCtx.category} ${discoveryCtx.entity} has ${attributeName}`}
            llmSources={sources}
            title={``}
            showSnippets
            disableAction
            showSources
            tooltip={attributeName}
            llm={discoveryCtx.llm}
          >
            <ListItemText
              sx={{
                "& .MuiListItemText-primary": {
                  fontSize: 12,
                  color: "#1B2559",
                  fontWeight: 400,
                  whiteSpace: "nowrap",
                  textAlign: "center",
                  overflow: "hidden",
                  maxWidth: 240,
                  textOverflow: "ellipsis",
                },
                display: "flex",
                justifyContent: "center",
              }}
              primary={attributeName}
            />
          </MUIToolTip>
        </ListItemButton>
      </ListItem>
    );
  };

  let positiveAttributes = [];
  let negativeAttributes = [];
  let loading = true;
  let brandData = discoveryCtx.positive_negative_attributes || [];
  let hasError = false;
  const transactionStatus = discoveryCtx.state.transactionStatus;

  if (Array.isArray(brandData) && brandData.length > 0) {
    const mainBrand = brandData.find(
      (brand) => brand.name === discoveryCtx.entity
    );

    if (mainBrand) {
      positiveAttributes = mainBrand?.positives;
      negativeAttributes = mainBrand?.negatives;
      loading = false;
    }
  } else if (transactionStatus === "RETRY") {
    hasError = true;
    loading = false;
  } else if (transactionStatus === "RUNNING") {
    hasError = false;
    loading = true;
  }

  return (
    <MUICard
      title={
        discoveryType === "brand" ? "Institution Attributes" : "Program Attributes"
      }
      className={classes.card}
      titleClassName={classes.title}
      variant="elevated"
      elevation={0}
    >
      {loading && !hasError && <LoadingSkeleton />}
      {!loading && !hasError && (
        <div className={classes.table_container}>
          <MUIList
            className={classes.list}
            title="Positive"
            data={positiveAttributes}
            render={renderRow}
          />
          <MUIList
            className={classes.list}
            title="Negative"
            data={negativeAttributes}
            render={renderRow}
          />
        </div>
      )}
      {hasError && (
        <div className={classes.error_view}>
          <ErrorView
            title={`Error Fetching ${discoveryType === "brand" ? "Brand Attributes" : "Product Attributes"}`}
            message={"Request Failed"}
          />
        </div>
      )}
    </MUICard>
  );
}
